import React, { useState } from 'react'
import { EDIT_TICKET } from '../../../graphql/mutation'
import { useMutation } from '@apollo/client'
import { toast } from 'react-toastify'
import { GET_TICKET_BY_BGACCOUNT } from '../../../graphql/query'
import { Loader } from 'react-bootstrap-typeahead'
import { v4 as uuidv4 } from 'uuid'
interface IProps {
  closeModal: any
  editTicketData: any
  getCategoryLabel: any
}

const EditTicketModal: React.FC<IProps> = ({ closeModal, editTicketData, getCategoryLabel }) => {
  const [categoryTypeId, setCategoryTypeId] = useState<any>(editTicketData?.TypeId)
  const [editTitle, setEditTitle] = useState<any>(editTicketData?.title)
  const [editDesc, setEditDesc] = useState<any>(editTicketData?.description)

  const categoryOption = [
    { name: 'Support', value: 1 },
    { name: 'Development', value: 2 },
    { name: 'Service', value: 3 }
  ]

  const [editTicket, { loading: mutationLoading }] = useMutation(EDIT_TICKET, {
    refetchQueries: [
      {
        query: GET_TICKET_BY_BGACCOUNT,
        context: {
          headers: {
            'access-control-allow-methods': 'Admin-Tickets'
          }
        }
      }
    ],

    context: {
      headers: {
        'access-control-allow-methods': 'Admin-Tickets'
      }
    }
  })

  const editHandler = async (e: any) => {
    e.preventDefault()
    console.log('working edit modal')
    if (!editDesc || !editTitle) {
      return toast.error('Please fill the required fields')
    }
    try {
      const inputData = {
        ticketId: editTicketData?.id,
        subject: editTitle,
        categoryTypeId: +categoryTypeId,
        description: editDesc
      }

      const { data } = await editTicket({
        variables: {
          input: inputData
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Admin-Tickets'
          }
        }
      })
      closeModal()
      toast.success(data?.editTicket?.message)
    } catch (error) {
      console.error('Error editing ticket:', error)
    }
  }
  const handleCategoryChange = (event: any) => {
    console.log(event.target.value)
    setCategoryTypeId(event.target.value)
  }

  const editTitleHandler = (e: any) => {
    setEditTitle(e.target.value)
  }

  const editDescriptionHandler = (e: any) => {
    setEditDesc(e.target.value)
  }

  return (
    // <form>
    <form style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '20px',
          width: '100%'
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginTop: '20px' }}>
          <p className='mb-0 d-flex align-items-center w-100'>
            <label
              htmlFor='subject'
              style={{ fontSize: '15px', fontWeight: '700', color: '#4b4b4b', width: '25%' }}
            >
              Title:
            </label>
            {/* <span style={{ flex: '1' }}>{editTicketData?.title}</span> */}
            <input
              style={{ flex: '1' }}
              required
              className='form-control'
              placeholder={editTicketData?.title}
              type='text'
              onChange={editTitleHandler}
              value={editTitle}
            />
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: '20px' }}>
          <p className='mb-0 d-flex align-items-center w-100'>
            <label
              htmlFor='subject'
              style={{ fontSize: '15px', fontWeight: '700', color: '#4b4b4b', width: '25%' }}
            >
              Description:
            </label>
            <input
              required
              className='form-control'
              style={{
                flex: '1',
                width: '50%',

                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                overflow: 'hidden'
              }}
              type='text'
              placeholder={editTicketData?.description}
              value={editDesc}
              onChange={editDescriptionHandler}
            />
          </p>
          <div className='mb-0 d-flex align-items-center w-100'>
            <label
              htmlFor='subject'
              style={{
                fontSize: '15px',
                fontWeight: '700',
                color: '#4b4b4b',
                width: '25%',
                whiteSpace: 'nowrap'
              }}
            >
              Update Category:
            </label>
            <select
              id='categorySelect'
              className='form-select form-select-solid form-select'
              style={{ flex: '1' }}
              onChange={handleCategoryChange}
            >
              <option disabled selected value=''>
                {getCategoryLabel(editTicketData.TypeId)}
              </option>
              {categoryOption
                ?.filter((category) => category?.name !== getCategoryLabel(editTicketData.TypeId))
                .map((categoryName, index) => (
                  <option key={uuidv4()} value={categoryName?.value}>
                    {categoryName?.name}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          gap: '20px',
          marginTop: '20px',
          width: '100%',
          justifyContent: 'end'
        }}
      >
        <button className='btn btn-primary mt-4 px-4 w-25' onClick={editHandler}>
          {mutationLoading ? (
            <div>
              Submiting <Loader />
            </div>
          ) : (
            'Submit'
          )}
        </button>
      </div>
    </form>
    // </form>
  )
}

export default EditTicketModal
